import { useState } from 'react';
import { api } from '../../lib/api';
import { LANGUAGES } from '../../i18n';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Sparkles } from 'lucide-react';

export default function StandardFeaturesTab({ initial, onReload }) {
  const [state, setState] = useState(initial || { translations: {} });

  const save = async () => {
    await api.put('/admin/standard-features', state);
    toast.success('Standard features saved');
    onReload();
  };

  const translateAll = async () => {
    const src = state.translations?.it;
    if (!src) { toast.error('Fill IT first'); return; }
    toast.info('Translating…');
    const upd = { ...state.translations };
    for (const tgt of LANGUAGES.filter(x => x.code !== 'it')) {
      if (upd[tgt.code]) continue;
      const { data } = await api.post('/admin/translate', { text: src, source_lang: 'it', target_lang: tgt.code });
      upd[tgt.code] = data.translation;
    }
    setState({ translations: upd });
    toast.success('Translated');
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-serif">Standard Features</h2>
          <p className="text-sm text-[#3D2817]/60">Shared block shown on every product detail page.</p>
        </div>
        <Button onClick={save} data-testid="save-standard">Save</Button>
      </div>
      <div className="space-y-4">
        {LANGUAGES.map(l => (
          <div key={l.code} className="border rounded-sm p-4">
            <div className="flex items-center justify-between mb-2">
              <Label className="text-xs uppercase tracking-widest">{l.flag} {l.label}</Label>
              {l.code === 'it' && (
                <Button variant="ghost" size="sm" onClick={translateAll}>
                  <Sparkles className="w-4 h-4 mr-1" /> Translate all
                </Button>
              )}
            </div>
            <Textarea data-testid={`standard-${l.code}`} rows={3}
              value={state.translations?.[l.code] || ''}
              onChange={e => setState({ ...state, translations: { ...state.translations, [l.code]: e.target.value } })} />
          </div>
        ))}
      </div>
    </div>
  );
}
